export const BROWSER_MAX_URL_LENGTH = {
  CHROME: 2083,
  FIREFOX: 65536,
  SAFARI: 80000,
  INTERNET_EXPLORER: 2083,
} as const

export const SAFE_MAX_URL_LENGTH = 2083
